import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M18 7c0-5.333-8-5.333-8 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 7v14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 21h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 13h10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PoundSterling";
const PoundSterling = memo(themed(Icon));
export {
  PoundSterling
};
//# sourceMappingURL=pound-sterling.js.map
